<template>
    <span v-tooltip="tooltipInfo" :class="getClasses">
        {{ signal }}
    </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    raw: Object,
    formatted: Object,
    label: String,
});

const timeframe = computed(() => {
    if (props.formatted.dailyTrendSpotterSignal) return 'daily';
    if (props.formatted.weeklyTrendSpotterSignal) return 'weekly';
    if (props.formatted.monthlyTrendSpotterSignal) return 'monthly';
    return '';
});

const signal = computed(() => {
    if (timeframe.value === '') return props.formatted.trendSpotterSignal;
    return props.formatted[`${timeframe.value}TrendSpotterSignal`];
});

const signalPrevious = computed(() => {
    if (timeframe.value === '') return props.formatted.trendSpotterSignalPrevious;
    return props.formatted[`${timeframe.value}TrendSpotterSignalPrevious`];
});

const trendChanged = computed(() => signal.value !== signalPrevious.value);

const getClasses = computed(() => {
    const classes = [];
    if (signal.value === 'Down') {
        classes.push('text-down');
    } else if (signal.value === 'Up') {
        classes.push('text-up');
    } else {
        classes.push('text-unch');
    }
    if (trendChanged.value) {
        classes.splice(-1, 0, 'cursor-pointer', 'border-b', 'border-dashed', 'border-gray-500', 'font-bold');
    }
    return classes;
});

const tooltipInfo = computed(() => {
    if (trendChanged.value) {
        return {
            theme: 'light',
            content: getContent(),
            placement: 'auto-start',
        };
    }
});

function getContent() {
    let textClass;
    let iconClass;

    if (signal.value === 'Down') {
        textClass = 'text-down';
        iconClass = 'fa-caret-down';
    } else if (signal.value === 'Up') {
        textClass = 'text-up';
        iconClass = 'fa-caret-up';
    } else {
        textClass = 'text-unch';
        iconClass = 'fa-minus';
    }

    return `
        <div style="min-width:8rem;">
            <div class="font-bold mb-3">${props.formatted.symbolName}<i class="fas text-lg ml-2 ${textClass} ${iconClass}"></i></div>
            <div class="text-xs font-bold text-gray-500 mb-1">PREVIOUSLY</div>
            <div class="mb-1"><span class="mr-2">Trend:</span><span class="float-right ${textClass}">${signalPrevious.value}</span></div>
            <div><span class="mr-2">Rank:</span><span class="float-right ${textClass}">${props.formatted[`${timeframe.value}TrendSpotterDirectionPrevious`]}</span></div>
        </div>
    `;
}
</script>
